<div>
  <div class="md:flex md:items-center md:justify-between py-8">
    <div class="min-w-0 flex-1">
      <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Vestra Shop</h2>
    </div>
    <div class="mt-4 flex md:ml-4 md:mt-0">
      <button
        type="button"
        (click)="toggleTableRows()"
        class="rounded-md bg-stone-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-stone-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-stone-600"
      >
        Afficher/masquer toutes les variantes
      </button>
    </div>
  </div>
</div>

<table mat-table [dataSource]="dataProductsList" multiTemplateDataRows>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Nom</th>
    <td mat-cell *matCellDef="let product" [ngClass]="{ loading: product.isLoading }">{{ product.name }}</td>
  </ng-container>

  <ng-container matColumnDef="categories">
    <th mat-header-cell *matHeaderCellDef>Catégories</th>
    <td mat-cell *matCellDef="let product" [ngClass]="{ loading: product.isLoading }">{{ product.category.name }}</td>
  </ng-container>

  <ng-container matColumnDef="brand">
    <th mat-header-cell *matHeaderCellDef>Marque</th>
    <td mat-cell *matCellDef="let product" [ngClass]="{ loading: product.isLoading }">{{ product.brand }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let product">
      <div class="flex justify-end">
        <button
          (click)="product.isExpanded = !product.isExpanded"
          class="px-2 py-1 text-sm font-semibold text-gray-900 hover:bg-gray-50"
        >
          <svg
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
            class="mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500 inline-block"
          >
            <path
              fill-rule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clip-rule="evenodd"
              class="ng-tns-c2145528021-17"
            ></path>
          </svg>
          <span class="pr-1" [ngClass]="{ loading: product.isLoading }">{{ product.variants.length }} variantes</span>
        </button>
        <button
          type="button"
          (click)="editVariant(product)"
          class="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          [ngClass]="{ loading: product.isLoading }"
        >
          @if (!editVariantInProgress) {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500 inline-block"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
              />
            </svg>
            <span class="pr-1">Éditer</span>
          } @else {
            <svg
              class="animate-spin ml-2 h-5 w-5 text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>
          }
        </button>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let product" [attr.colspan]="displayedColumns.length">
      <div class="row student-product-detail detailExpand" [class.expanded]="product.isExpanded">
        <ul role="list" class="divide-y divide-gray-100">
          @for (article of product.variants; track article.id) {
            <li class="relative flex justify-between gap-x-6 py-2 px-4">
              <div class="flex min-w-0 gap-x-4">
                <div class="min-w-0 flex-auto">
                  <p class="text-sm font-semibold leading-6 text-gray-900">
                    <span class="">
                      {{ article.color.name }}
                    </span>
                  </p>
                  @for (size of article.sizes; track size.id) {
                    <p class="mt-1 flex text-xs leading-5 text-gray-500">
                      @if (size.quantity > 0) {
                        <span class="relative truncate hover:underline">
                          {{ size.name }} | Quantité: {{ size.quantity }}
                        </span>
                      }
                    </p>
                  }
                </div>
              </div>
              <div class="flex shrink-0 items-center gap-x-4">
                <a (click)="deleteItem(article)" class="text-stone-600 hover:text-stone-900">Retirer de Vestra</a>
              </div>
            </li>
          }
        </ul>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr
    mat-row
    *matRowDef="let product; columns: displayedColumns"
    class="student-product-row"
    [class.product-expanded-row]="product.isExpanded"
  ></tr>

  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="product-detail-row"></tr>
</table>
